import React from 'react';

const SuperpartnerInfo = ({ superpartnerData }) => {
    if (!superpartnerData) {
        return <p>Nessun dato da visualizzare.</p>;
    }

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-md-6 my-2">
                    <span className="small text-muted d-block"><b>Nome Superpartner</b></span>
                    <span className="d-block">{superpartnerData.nome}</span>
                </div>
                <div className="col-md-6 my-2">
                    <span className="small text-muted d-block"><b>Partita IVA</b></span>
                    <span className="d-block">{superpartnerData.piva}</span>
                </div>
                <div className="col-md-6 my-2">
                    <span className="small text-muted d-block"><b>Indirizzo</b></span>
                    <span className="d-block">{superpartnerData.indirizzo || '-'}, {superpartnerData.cap || '-'}, {superpartnerData.citta || '-'} ({superpartnerData.provincia || '-'})</span>
                </div>
                <div className="col-md-6 my-2">
                    <span className="small text-muted d-block"><b>Referente</b></span>
                    <span className="d-block">{superpartnerData.referente}</span>
                </div>
                 <div className="col-md-6 my-2">
                    <span className="small text-muted d-block"><b>Email</b></span>
                    <span className="d-block">{superpartnerData.email}</span>
                </div>
                <div className="col-12 my-2">
                    <span className="small text-muted d-block"><b>Note</b></span>
                    <p style={{ whiteSpace: 'pre-wrap' }}>{superpartnerData.note || 'Nessuna nota.'}</p>
                </div>
            </div>
        </div>
    );
};

export default SuperpartnerInfo;